<template>
  <div class="container">
    <div class="">
      <div class="card-header">
        <div class="contenedor2ColumnasImageNoticias">
          <img class="card-img-top" :src="articulo.Imagen" style="width: 100%; height:auto" />
        </div>
        <div class="contenedor2ColumnasImageNoticias2">
          <h1 style="margin-bottom:8px">{{ articulo.Nombre }}</h1>

          <div class="card-body">
            <div class="card-text" style="margin-bottom: 15px">
              <span> {{ articulo.Referencia }} - {{ articulo.Nombre }} </span>
              <span
                v-if="articulo.cantidad_stock > 0 && articulo.ControlStock"
                class="Stock"
                style="font-size: 9px; line-height: 6px"
            >{{ $t("articulo.stock") }} {{ articulo.CantidadStock }}</span
          >
              <label
                v-else-if="articulo.ControlStock"
                class="NoStock"
                style="font-size: 9px; line-height: 6px"
            >{{ $t("articulo.no_stock") }}</label
          >
            </div>
            <div class="card-text" v-html="articulo.Observaciones"></div>

            <div class="card-text" style="font-size: 40px; font-weight: 700; margin-top: 10px; color: rgb(48, 48, 48);">{{ total }} {{ articulo.Moneda }}</div>
            <!-- <div>{{ cantidad }}</div>
				  <div class="contenedorBoton" style="float: left;"> -->
            <!-- <a class="btn btn-success" v-on:click="incrementarCantidad" >+</a>
					<a v-if="cantidad > 1" :disabled="desactivar_boton" class="btn btn-danger" v-on:click="decrementarCantidad">-</a> -->
          </div>


          <div class="card-footer">
            <a
              class="btn btn-success"
              v-if="articulo.Vendible && canAdd"
              v-on:click.prevent="anyadirAlCarro"
              href=""
        >
              <img
                style="margin-right: 5px; vertical-align: middle"
                :src="src_carro"
          />
              <label>{{ $t("acciones.anyadir_al_carro") }}</label>
            </a>
          </div>
          
        </div>
      </div>

      

      <!-- </div> -->


      
      
      
    </div>
  </div>
</template>
<script>
import { ArticuloSeccion } from "../model.js";
import Servicios from "../services.js";
export default {
  data() {
    return {
      src_carro: "dist/img/icon-carro.png",
      articulo: new ArticuloSeccion(),
      total: 0,
      cantidad: 1,
      desactivar_boton: false,
    };
  },
  props: {},
  computed: {
    canAdd: function () {
      const cantidadActual = this.$store.getters.getCantidad(this.articulo);
      return (
        !this.articulo.ControlStock ||
        this.cantidad + cantidadActual <= this.articulo.CantidadStock
      );
    },
  },
  watch: {
    cantidad: function () {
      if (this.cantidad == 0) {
        this.desactivar_boton = true;
      } else {
        this.desactivar_boton = false;
      }
    },
    $route(to, from) {
      console.log("watch to", to, "from", from);
      if (to.name == "article") {
        const idArticulo = to.params.id;
        console.log("beforeRouteUpdated", idArticulo);
        this.obtenerDetalleArtiuclo(idArticulo);
      }
    },
  },
  methods: {
    incrementarCantidad() {
      if (
        !this.articulo.ControlStock ||
        this.cantidad + 1 <= this.articulo.CantidadStock
      ) {
        this.cantidad++;
        this.total = this.cantidad * this.articulo.precio;
      }
    },
    decrementarCantidad() {
      this.cantidad--;
      this.total = this.cantidad * this.articulo.precio;
    },
    anyadirAlCarro() {
      const cantidadActual = this.$store.getters.getCantidad(this.articulo);
      if (
        !this.articulo.ControlStock ||
        cantidadActual + this.cantidad <= this.articulo.CantidadStock
      ) {
        console.log("anyadirAlCarro");
        this.$store.commit("addLinea", this.articulo, this.cantidad);
      }
    },
    obtenerDetalleArtiuclo(idArticulo) {
      Servicios.ObtenerDetalleArcitulo(idArticulo).then((respuesta) => {
        var reg = respuesta.data.d;
        this.articulo.Id = reg.Id;
        this.articulo.Referencia = reg.Referencia;
        this.articulo.Nombre = reg.Nombre;
        this.articulo.CantidadStock = reg.CantidadStock;
        this.articulo.Precio = reg.Precio;
        this.articulo.Contro = reg.Precio;
        this.total = reg.Precio;
        this.articulo.Observaciones = reg.Observaciones;
        this.articulo.Vendible = reg.Vendible;
        this.articulo.ControlStock = reg.ControlStock;
        if (reg.Id_Imagen === "") {
          this.articulo.Imagen = "dist/img/sin-image-actividad.png";
        } else {
          this.articulo.Imagen =
            "/images.ashx?maxheight=300&maxwidth=300&id=" + reg.Id_Imagen;
        }
      });
    },
  },
  mounted() {
    console.log("mounted articulo");
    var idArticulo = this.$route.params.id;
    var vm = this;
    this.obtenerDetalleArtiuclo(idArticulo);
  },
};
</script>
